module.exports = __webpack_public_path__ + "static/media/modal-close-mobile-white.91edf0bc.svg";